import PropTypes from 'prop-types';

import { JobStakeholdersPopupType } from 'src/components/JobForm/constants';

/* PropTypes */

export const JobStakeholdersPopupComponentPropTypes = {
  disabled: PropTypes.bool.isRequired,
  jobId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  type: PropTypes.oneOf(Object.values(JobStakeholdersPopupType)).isRequired,
  excludedUsersIds: PropTypes.arrayOf(PropTypes.number),
  jobStakeholder: PropTypes.object,
};

/* DefaultProps */

export const JobStakeholdersPopupComponentDefaultProps = {
  excludedUsersIds: [],
};
